import { Action, Field } from '@/components/general/list-view/types'
import { createFeatureList } from '../list'

const productFieldsGroup = {
  key: 'productDetails',
  localeString: {
    sv: 'Produktdetaljer',
    en: 'Product details'
  }
}

export const productFields: Field[] = [
  {
    key: 'name',
    type: 'text',
    showInViews: ['minimized', 'fullscreen'],
    translationKey: 'general__text__name',
    group: productFieldsGroup,
    required: true
  },
  {
    key: 'labels.description',
    type: 'text',
    translationKey: 'description',
    area: true,
    group: productFieldsGroup
  },
  {
    key: 'labels.brandOwner',
    type: 'text',
    showInViews: ['fullscreen'],
    localeString: { en: 'Brand owner', sv: 'Varumärkesägare' },
    group: productFieldsGroup
  },
  {
    key: 'labels.brand',
    type: 'text',
    showInViews: ['minimized', 'fullscreen'],
    localeString: { en: 'Brand', sv: 'Varumärke' },
    group: productFieldsGroup
  },
  {
    key: 'labels.manufactureCountry',
    type: 'text',
    localeString: { en: 'Manufacture country', sv: 'Tillverkningsland' },
    group: productFieldsGroup
  },
  {
    key: 'labels.productId',
    type: 'text',
    localeString: { en: 'Product ID', sv: 'Produkt-ID' },
    group: productFieldsGroup
  },
  {
    key: 'labels.color',
    type: 'text',
    showInViews: ['fullscreen'],
    localeString: { en: 'Color', sv: 'Färg' },
    group: productFieldsGroup
  },
  {
    key: 'labels.material',
    type: 'text',
    showInViews: ['fullscreen'],
    localeString: { en: 'Material', sv: 'Material' },
    group: productFieldsGroup
  },
  {
    key: 'labels.environmentalImpact',
    type: 'number',
    min: 0,
    step: 0.01,
    localeString: { en: 'Environmental impact (kgCO₂e)', sv: 'Miljöpåverkan (kgCO₂e)' },
    group: productFieldsGroup
  },
  {
    key: 'labels.environmentalProductDeclaration',
    type: 'boolean',
    localeString: {
      en: 'Environmental product declaration (EPD)',
      sv: 'Miljöproduktdeklaration (EPD)'
    },
    group: productFieldsGroup
  },
  {
    key: 'labels.heavyObject',
    type: 'boolean',
    localeString: { en: 'Heavy object', sv: 'Tungt föremål' },
    group: productFieldsGroup
  }
]

const actions: Action[] = [
  {
    actionName: 'new',
    type: 'new',
    labelKey: 'general__text__new',
    icon: 'IconBox',
    access: 'CREATOR'
  },
  {
    actionName: 'edit',
    type: 'single',
    icon: 'IconEditSmall',
    labelKey: 'general__text__change',
    access: 'EDITOR',
    replaces: ['view'],
    hiddenInModal: true
  },
  {
    actionName: 'view',
    type: 'single',
    hiddenInModal: true,
    icon: 'IconFileSearch',
    labelKey: 'general__text__open',
    access: 'READER'
  },
  {
    actionName: 'delete',
    type: 'bulk',
    labelKey: 'general__text__delete',
    icon: 'IconTrash2Small',
    access: 'ADMIN'
  }
]

export const productsList = createFeatureList({
  type: 'PRODUCT',
  icon: 'IconBox',
  title: {
    en: 'Products',
    sv: 'Produkter'
  },
  component: 'ProductDashboard',
  mainPathFilter: false,
  // productFields drives the accordion sections in EntityDetails when a linked product is shown
  // for an asset. Consumed indirectly via useFeatureFields — do not remove as "unused".
  fields: productFields,
  actions
})
